export type TApiConfig = {
  baseUrl: string
  authUrl: string
}

export type TApiConfigOptions = {
  publisher?: {
    development: TApiConfig
    production: TApiConfig
  }
  admin?: {
    development: TApiConfig
    production: TApiConfig
  }
}

const defaultConfig: TApiConfigOptions = {
  publisher: {
    development: {
      baseUrl: 'http://publisher.devserv/api/v1/publisher',
      authUrl: 'http://publisher.devserv/api/v1/publisher',
    },
    production: {
      baseUrl: 'https://backend.sl.halleonard.com/api/v1/publisher',
      authUrl: 'https://backend.sl.halleonard.com/api/v1/publisher',
    },
  },
  admin: {
    development: {
      baseUrl: 'http://admin.devserv/api/v1/internal',
      authUrl: 'http://admin.devserv/api/v1/internal',
    },
    production: {
      baseUrl: 'https://backend.sl.halleonard.com/api/v1/internal',
      authUrl: 'https://backend.sl.halleonard.com/api/v1/internal',
    },
  },
}

export const getApiConfig = (app: 'publisher' | 'admin'): TApiConfig => {
  const envBaseUrl = process.env.ZENDESK_BACKEND_URL
  const envAuthUrl = process.env.ZENDESK_AUTH_URL

  if (envBaseUrl && envAuthUrl) {
    return {
      baseUrl: envBaseUrl,
      authUrl: envAuthUrl,
    }
  }

  const isDevelopment = process.env.NODE_ENV === 'development'
  const environment = isDevelopment ? 'development' : 'production'
  const appConfig = defaultConfig[app]

  if (!appConfig) {
    throw new Error(`No configuration found for app: ${app}`)
  }

  return appConfig[environment]
}

export const createApiConfig = (app: 'publisher' | 'admin') => {
  const config = getApiConfig(app)

  return {
    apiConfig: config,
    API_BASE_URL: config.baseUrl,
    AUTH_API_URL: config.authUrl,
  }
}
